<template>
  <el-select
    v-model="value"
    style="width: 100%"
    :disabled="disabled"
    @change="handleChange"
    filterable
  >
    <el-option
      v-for="subItem in options"
      :key="subItem.id"
      :label="subItem.name"
      :value="subItem.id"
    />
  </el-select>
</template>

<script>
/**
 * 上级选择器, 用法和el-select一样，已嵌入到BaseInfo
 */

export default {
  name: "DefaultSelect",
  props: {
    value: {
      type: String,
      default: ''
    },
		visible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
	},
  data() {
    return {
      bindVal: "",
      options: "",
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.bindVal = ""
      }
		},
  },
  created() {
    this.getShopList();
  },
  methods: {
    handleChange(value) {
      // 模拟formItem, 实现v-model
      this.$emit("input", value);
      this.$emit("change", value);
    },
    getShopList() {
			this.$axios
				.$post('/rest/store/contact/v3/contactshopsidnamelist', {
					current: 1,
					page_size: 1000
				})
				.then(({ code, data }) => {
					if (code !== 200) return;
					this.options = data.list.map(({ id, name }) => ({ id, name }));
				});
		},
  },
};
</script>
